import styled from 'styled-components';
import { ModalIncompletePxStyled } from '../ModalIncompletePxStyled';
import { rem } from 'polished';

export const ModalIncompletePxStyledOV = styled(ModalIncompletePxStyled)`
    
`;
